import axios from "axios";
const errorsHandler = require("@/services/errors")

const module = 'roles/permissions'

const state = {
    permissions:[],
    roles:[]
}

const getters = {
    getPermissions: state => {
        return state.permissions
    },
    getRoles: state => {
        return state.roles
    },
}

const actions = {

    getList : async (context,payload) => {

        let url = `api/v1/${module}`;

        return await axios.get(`${context.rootGetters['settings/getEndpoint']}${url}`, {
                'headers': {'Authorization': `Bearer ${context.rootGetters['user/getUser'].token}`},
                "Content-Type": "application/json"
            },
        ).then(result => {

            return result.data

        }).catch(error => {
            return errorsHandler.errorHandler(error)
        });

    },
    permissionList : async (context,payload) => {

        let url = `api/v1/${module}/${payload.id}`;

        return await axios.get(`${context.rootGetters['settings/getEndpoint']}${url}`,{
                'headers': {'Authorization': `Bearer ${context.rootGetters['user/getUser'].token}`},
                "Content-Type": "application/json"
            },
        ).then(result => {

            context.commit('setPermissions', result.data.result.permissions)
            return result.data.result.permissions

        }).catch(error => {
            return errorsHandler.errorHandler(error)
        });

    },
    permissionUpdate : async (context,payload) => {

        let url = `api/v1/${module}/update/${payload._id}`;

        var formData = {permissions: payload.permissions}

        return await axios.post(`${context.rootGetters['settings/getEndpoint']}${url}`,formData,{
                'headers': {'Authorization': `Bearer ${context.rootGetters['user/getUser'].token}`},
                "Content-Type": "application/json"
            },
        ).then(result => {

            return {
                success: true,
                result: result.data
            }

        }).catch(error => {
            return errorsHandler.errorHandler(error)
        });

    },
}

const mutations = {
    setPermissions: (state, value) => {
        state.permissions = value
    },
    setRoles: (state, value) => {
        state.roles = value
    },
}


export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}

